
import { useEffect } from "react";
import { extendTheme, styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid2';
import Stack from '@mui/material/Stack';
import Skeleton from '@mui/material/Skeleton';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import "../components/index.css";
import Category from '@mui/icons-material/Category';
import Inventory from '@mui/icons-material/Inventory';
import AddHomeIcon from '@mui/icons-material/AddHome';
import Typography from '@mui/material/Typography';
import AgricultureIcon from '@mui/icons-material/Agriculture';
import QueryStats from '@mui/icons-material/QueryStats';
import Piechart from '../components/Piechart';
import Linechart from '../components/LineChart';
import Barchart from '../components/BarChart';
import Nodata from './nodatafound';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getadmin } from '../redux/admin';
import { getfarmer } from '../redux/farmer';
import { getproduct } from '../redux/product';
import { getstaff } from '../redux/staff';
import { getsales } from '../redux/sales';
import List from '@mui/material/List';
import * as React from 'react';

import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';


const Dashboard = () => {
  const dt = new Date()
  const time = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
  const day = dt.getUTCDate();
  const month = String(dt.getMonth() + 1).padStart(2, '0');
  const year = dt.getFullYear();
  const date = year + "-" + month + "-" + day;
  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  var pusher = []

  const dispatch = useDispatch()
  const admin = useSelector((state) => state.admin)
  const farmer = useSelector((state) => state.farmer)
  const purchase = useSelector((state) => state.purchase)
  const product = useSelector((state) => state.product)
  const customers = useSelector((state) => state.customer)
  const staff = useSelector((state) => state.staff)
  const sales = useSelector((state) => state.sales)
  const agent = useSelector((state) => state.agent)
  const warehouse = useSelector((state) => state.warehouse)
  const service = useSelector((state) => state.service)
  const center = useSelector((state) => state.center)
  const commodity = useSelector((state) => state.commodity)



  useEffect(() => { 




    // getPromise(["sales", "purchases"]);
  }, []);
  // const { loading, error } = useSelector((state) => state.stock);
  var saleslister=[]
  const salescalc=()=>{
    
    var currentmonth= parseInt(month)
   
    var totalvalue = 0
    for(var i in sales){
   
      if(currentmonth===parseInt(sales[i].date.split("-")[1]))
        for (var k in sales[i].purchase){
          var value = parseFloat(sales[i].purchase[k].qty) * parseFloat(sales[i].purchase[k].unitp)
          totalvalue+=parseFloat(value ? value:0)
      saleslister.push({product:sales[i].purchase[k].product , amount:value})
      }
      
    }
    
    return totalvalue

  }

 

 for(var i  in commodity){
  var user=commodity[i]
  var dated = user.expecteddate
  var difference= parseInt(( parseInt(new Date(dated+"").getTime()) - parseInt(new Date(date+"").getTime())))
 
  if(difference<=0 && (user.status!=="Received")){
    //    schedule notification

  pusher.push(user)
   
  }
}


  return (
    <>
            

        <Grid container spacing={1}>
        <Grid size={3}>
              {/* <Skeleton  height={200} /> */}


              <Paper style={{ "background-color": "rgba(255, 0, 71, 1)"}} class="dashboardcontainer" height={200} >
              <div style={{display:"flex", paddingTop:"15px"}}>
               
                <span style={{width:"50px", height:"50px", marginRight:"10px", borderRadius:"50%", "background-color": "rgba(0, 0, 0, 0.4)" , padding:"5px", display:"flex", "justify-content": "center", "align-content": "center", "align-items": "center"}}> <Category/> </span><h1 style={{marginTop:"-2px"}}>    
                  

              <Typography variant="h3" gutterBottom>
                  {customers.length}
                </Typography>

                </h1>
              </div>
              <p style={{position:"absolute", bottom:0, right:1, marginBottom:"3px", marginRight:"5px"}}>  <Typography variant="overline" gutterBottom sx={{ display: 'block' }}>
                Customers
              </Typography></p>
              </Paper>

            </Grid>




            <Grid size={3}>
              {/* <Skeleton height={200} /> */}


              <Paper style={{ "background-color": "rgba(45, 10, 203, 1)"}} class="dashboardcontainer1" height={200} >
              <div style={{display:"flex", paddingTop:"15px"}}>
               
                <span style={{width:"50px", height:"50px", marginRight:"10px", borderRadius:"50%", "background-color": "rgba(0, 0, 0, 0.4)" , padding:"5px", display:"flex", "justify-content": "center", "align-content": "center", "align-items": "center"}}> <AgricultureIcon/> </span><h1 style={{marginTop:"-2px"}}>    
                  

              <Typography variant="h3" gutterBottom>
                  {farmer.length}
                </Typography>

                </h1>
              </div>
              <p style={{position:"absolute", bottom:0, right:1, marginBottom:"3px", marginRight:"5px"}}>  <Typography variant="overline" gutterBottom sx={{ display: 'block' }}>
                Farmers
              </Typography></p>
              </Paper>

            </Grid>



            <Grid size={3}>
              {/* <Skeleton height={200} /> */}

              <Paper style={{ "background-color": "rgba(66, 714, 71, 1)"}} class="dashboardcontainer2" height={200} >
              <div style={{display:"flex", paddingTop:"15px"}}>
               
                <span style={{width:"50px", height:"50px", marginRight:"10px", borderRadius:"50%", "background-color": "rgba(0, 0, 0, 0.4)" , padding:"5px", display:"flex", "justify-content": "center", "align-content": "center", "align-items": "center"}}> <Inventory/> </span><h1 style={{marginTop:"-2px"}}>    
                  

              <Typography variant="h3" gutterBottom>
                  {staff.length}
                </Typography>

                </h1>
              </div>
              <p style={{position:"absolute", bottom:0, right:1, marginBottom:"3px", marginRight:"5px"}}>  <Typography variant="overline" gutterBottom sx={{ display: 'block' }}>
               Staff
              </Typography></p>
              </Paper>


            </Grid>

            <Grid size={3}>
              {/* <Skeleton height={200} /> */}

              <Paper style={{ "background-color": "rgba(0, 112, 71, 1)"}} class="dashboardcontainer3"  >
              <div style={{display:"flex", paddingTop:"15px"}}>
               
                <span style={{width:"50px", height:"50px", marginRight:"10px", borderRadius:"50%", "background-color": "rgba(0, 0, 0, 0.4)" , padding:"5px", display:"flex", "justify-content": "center", "align-content": "center", "align-items": "center"}}> <QueryStats/> </span><h1 style={{marginTop:"-2px"}}>    
                  

              <Typography variant="h3" gutterBottom>
                  {salescalc()}
                </Typography>

                </h1>
              </div>
              <p style={{position:"absolute", bottom:0, right:1, marginBottom:"3px", marginRight:"5px"}}>  <Typography variant="overline" gutterBottom sx={{ display: 'block' }}>
                Sales ({months[parseInt(month)-1]}, {year})
              </Typography></p>
              </Paper>

            </Grid>

            <Grid size={5} />

            {/* <Grid size={12}>
              <Skeleton height={14} />
            </Grid> */}


            <Grid size={12}>
              {/* <Skeleton height={14} /> */}
            </Grid>


            <Grid height={100}  size={5}>
              {/* <Skeleton height={100} /> */}
              <Paper>
              <p style={{textAlign:"center"}}>  <Typography variant="overline" gutterBottom sx={{ display: 'block' }}>
              Commodity Aggregation Time Over-due ({pusher.length})
              </Typography></p>

              {/* <Piechart/> */}
              <div style={{width:"100%", height:200,overflow:"scroll" }}>
              <List sx={{ width: '100%',  bgcolor: 'background.paper' }}>
      {pusher.map((list,i)=>
      <>
      <ListItem alignItems="flex-start">
        <ListItemAvatar>
          <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" />
        </ListItemAvatar>
        <ListItemText
          primary={list.agent}
          secondary={
            <React.Fragment>
              <Typography
                component="span"
                variant="body2"
                sx={{ color: 'text.primary', display: 'inline' }}
              >
                Expected Date: {list.expecteddate}
              </Typography>
              {" — "+list.product}
            </React.Fragment>
          }
        />
      </ListItem>
      <Divider variant="inset" component="li" />
      </>
)}
     {pusher.length===0 && <Nodata/>}
    </List>

              </div>

              </Paper>
            </Grid>

            <Grid size={7}>
              {/* <Skeleton height={100} /> */}

              <Paper>

              <p style={{textAlign:"center"}}>  <Typography variant="overline" gutterBottom sx={{ display: 'block' }}>
              Sales ({months[parseInt(month)-1]}, {year})
              </Typography></p>

              <Linechart sales={saleslister} month={months[parseInt(month)-1]} />

                </Paper>

            </Grid>

            {/* <Grid size={12}> */}
            
                <Grid size={6}>
                <p style={{textAlign:"center"}}>  <Typography variant="overline" gutterBottom sx={{ display: 'block' }}>
              Products Inventory (Available At Warehouse)
              </Typography></p>

              <Barchart sales={purchase} status={"Received"}/>

                </Grid>

                <Grid size={6}>

                <p style={{textAlign:"center"}}>  <Typography variant="overline" gutterBottom sx={{ display: 'block' }}>
              Products Inventory (Expecting)
              </Typography></p>

              <Barchart sales={purchase}  status={"Expected"}/>

                {/* </Grid> */}
           
              
            </Grid>
           

          
          </Grid>  

     
     </>
  );
};

export default Dashboard;
